import * as React from 'react';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import { PlanInformation } from 'types/api/backorder';
import PlanTable from 'components/backorder/table/planTable/PlanTable';
import {
  currentPlanTableColumns,
  currentPlanTableHeader,
} from 'components/backorder/table/planTable/planTableData';

interface Props {
  currentPlan: PlanInformation;
}

const CurrentPlanTable = ({ currentPlan }: Props) => {
  return (
    <DataTableLayout description={<span>Date in UTC</span>}>
      <PlanTable<PlanInformation>
        planInformation={[currentPlan]}
        header={currentPlanTableHeader}
        columns={currentPlanTableColumns}
      />
    </DataTableLayout>
  );
};

export default CurrentPlanTable;
